<template>
    <v-row>
        <v-col
            cols="12"
            sm="8"
            md="6"
            lg="6"
            xl="4"
            offset-sm="2"
            offset-md="3"
            offset-lg="3"
            offset-xl="4"
            class="mt-4"
        >
            <v-card>
                <v-card-text>
                    <h2 class="text-center mb-3">Passwort ändern</h2>
                    <v-alert prominent class="mb-5">
                        <ul class="text-left mt-3 pl-5">
                            <li>Um Ihr Passwort zu ändern, drücken Sie bitte folgenden Knopf.</li>
                            <li>Sie bekommen dann eine E-Mail mit einem Link zugeschickt.</li>
                            <li>
                                Mit Hilfe dieses Links können Sie dann ein neues Passwort setzen.
                            </li>
                        </ul>
                    </v-alert>
                    <div class="mt-3 pb-2">
                        <v-btn
                            :disabled="isLoading || isPasswordRequested"
                            block
                            color="secondary"
                            type="submit"
                            :loading="isLoading"
                            @click="requestPasswordReset()"
                        >
                            Neues Passwort beantragen
                        </v-btn>
                    </div>
                    <common-general-error-alert v-if="hasError" />
                    <v-alert
                        v-if="isPasswordRequested && !hasError"
                        prominent
                        type="success"
                        class="mt-2"
                    >
                        <p class="font-weight-bold">Herzlichen Glückwunsch!</p>
                        <p class="mb-0">
                            Sie sollten eine Mail bekommen haben.
                            <br />
                            Bitte schauen Sie ggfs. auch in ihrem Spam-Ordner nach.
                            <br />
                            Alle weiteren Schritte stehen in der Mail.
                        </p>
                    </v-alert>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
    'use strict'
    export default {
        name: 'PasswordChangeRequest',
        data: () => ({
            isPasswordRequested: false
        }),
        computed: {
            isLoading() {
                return this.$store.getters['security/isLoading']
            },
            hasError() {
                return this.$store.getters['security/hasError']
            },
            error() {
                return this.$store.getters['security/error']
            },
            validation() {
                if (this.username.trim().length <= 20) {
                    return null
                }

                return this.username.trim().endsWith('@hs-anhalt.de')
            },
            user() {
                return this.$store.getters['security/currentUser']
            }
        },
        created() {},
        methods: {
            async requestPasswordReset() {
                await this.$store.dispatch('security/requestPasswordReset', {
                    email: this.user.email.email,
                    honeypot: ''
                })

                if (!this.hasError) {
                    this.isPasswordRequested = true
                }
            }
        }
    }
</script>

<style scoped></style>
